import { Component, HostListener } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AmbassadorSeoService } from './services/ambassador-seo.service';
import { AmbassadorProfileService } from './services/ambassador-profile.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'ambassadors';
  currentYear = new Date().getFullYear();
  isUserDropdownOpen = false;
  isMobileNavOpen = false;
  readonly fallbackProfilePhoto = 'https://res.cloudinary.com/dmsxiwqlj/image/authenticated/s--R31ac9P0--/v1774883132/user_profile_photos/lcyhuys1whhgtipcxw2o.jpg';
  readonly user$ = this.ambassadorProfile.authUser$;

  constructor(
    private readonly ambassadorProfile: AmbassadorProfileService,
    private readonly router: Router,
    seo: AmbassadorSeoService
  ) {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe(event => seo.update(event.urlAfterRedirects));
  }

  toggleMobileNav(): void {
    this.isMobileNavOpen = !this.isMobileNavOpen;
    if (this.isMobileNavOpen) {
      this.closeUserDropdown();
    }
  }

  closeMobileNav(): void {
    this.isMobileNavOpen = false;
  }

  toggleUserDropdown(): void {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  closeUserDropdown(): void {
    this.isUserDropdownOpen = false;
  }

  closeNavigationMenus(): void {
    this.closeUserDropdown();
    this.closeMobileNav();
  }

  async logout(): Promise<void> {
    this.closeNavigationMenus();
    await this.ambassadorProfile.signOut();
    await this.router.navigate(['/login']);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    if (this.isUserDropdownOpen && !target?.closest('.userbox')) {
      this.closeUserDropdown();
    }

    if (this.isMobileNavOpen && !target?.closest('.app-header')) {
      this.closeMobileNav();
    }
  }
}
